import { useState, useEffect, useRef } from "react";
import { useInlineValidation, InlineFieldError } from "./inlineValidation";

const FloatingLabelInput = ({ id, label, handleChange, handleBlur, value, error=null, name, type = 'text', required=false, placeholder = '', disabled=false, isCurrency=false }) => {
    const [isFocused, setIsFocused] = useState(false);
    const refContainer = useRef(null);
    // Inline message instead of the browser's "Please fill out this field." bubble.
    const { message: invalidMessage, onInvalid } = useInlineValidation({ label, value });

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleClickOutside = (event) => {
        if (refContainer.current && !refContainer.current.contains(event.target)) {
            setIsFocused(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
  
    return (
      <>
      <div className={`relative border rounded-md ${invalidMessage ? "border-red-400 ring-1 ring-red-200" : ""}`} ref={refContainer}>
          { isCurrency && (value || isFocused) && (
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              $
            </div>
          )}
        <input
          type={type}
          id={id}
          value={value}
          name={name}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          required={required}
          onInvalid={onInvalid}
          placeholder={placeholder}
          disabled={disabled}
          className={`number-input w-full border-none outline-none ring-0 focus:ring-0 ${value || isFocused ? 'bg-white' : 'bg-gray-50'} ${ isCurrency ? 'pl-10 pr-4' : 'pl-4'}`}
        />
        <label
          htmlFor={id}
          className={`absolute left-1 top-0 origin-left px-1 text-gray-500 text-sm transition-all ${value || isFocused ? '-translate-y-5 scale-75' : 'translate-y-1/2'}`}
        >
          {label}
          { required && <span className="text-red-600">*</span>}
        </label>
      </div>
        {error && <p className="text-red-500 text-xs italic">{error}</p>}
        {!error && <InlineFieldError message={invalidMessage} />}
      </>
    );
  };


export default FloatingLabelInput;